import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import { Button, Divider } from '@mui/material';
import { Title } from 'shared/components/abstract/interactables';
import { useNotification } from 'shared/hooks';
import { complexEntity } from 'shared/entityDetails';
import { VARIANTS } from 'shared/constants';
import * as routes from 'shared/routes/networking';
import { getComplexToolsPath } from 'shared/routes/networking';
import CardDisplay from 'features/networking/ui/CardDisplay';
import ComplexCard from 'features/networking/complex/ComplexCard';
import EntityPicker from 'features/networking/ui/EntityPicker';

const paramKey = 'complex_id';

export default function ComplexTools() {
  const { search } = useLocation();
  const { push: pushHistory } = useHistory();
  const { pushInfo } = useNotification();

  const [clearable, setClearable] = useState(false);

  useEffect(() => {
    const { length } = new URLSearchParams(search).getAll(paramKey);
    if (clearable && length === 0) {
      setClearable(false);
      return;
    }
    if (!clearable && length > 0) {
      setClearable(true);
    }
  }, [clearable, search]);

  const clear = () => {
    pushHistory(getComplexToolsPath([]));
  };

  function addComplex(complex) {
    const current = new URLSearchParams(search).getAll(paramKey);
    if (current.find((curr) => curr === complex.id.toString())) {
      pushInfo('Complex is already added');
    } else {
      pushHistory(getComplexToolsPath([complex.id, ...current]));
    }
  }

  return (
    <>
      <Title
        title="Complex Tools"
        titleLink={routes.buildingToolsPath}
      />
      <Grid container rowSpacing={1} columnSpacing={1} sx={{ alignItems: 'center' }}>
        <Grid size={{
          xs: 12,
          lg: 8,
        }}
        >
          <EntityPicker entity={{
            ...complexEntity,
            add: addComplex,
          }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 4,
          }}
          sx={(theme) => ({
            display: 'flex',
            mb: '5px',
            [theme.breakpoints.up('md')]: {
              justifyContent: 'end',
            },
          })}
        >
          <Button
            disabled={!clearable}
            variant={VARIANTS.outlined}
            onClick={clear}
          >
            Clear All
          </Button>
        </Grid>
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid size={12}>
          <CardDisplay
            cardComponent={ComplexCard}
            urlParamKey={paramKey}
          />
        </Grid>
      </Grid>
    </>
  );
}
